export class User {
  constructor(
    readonly userName: string,
    readonly email: string,
    readonly roles: Role[],
  ) {}

  hasDriverRole() {
    return this.hasRole(Role.DRIVER);
  }

  hasSharedDriverAccountRole() {
    return this.hasRole(Role.DRIVER_SHARED_ACCOUNT);
  }

  hasHandoverRole() {
    return this.hasRole(Role.HANDOVER);
  }

  hasAdminRole() {
    return this.hasRole(Role.ADMIN);
  }

  hasRole(role: Role) {
    return this.roles.includes(role);
  }
}

export interface UserSettings {
  readonly language: string | null;
  readonly opcoCode: string | null;
  readonly depotId: string | null; // Is null for drivers.
}

export enum Role {
  DRIVER = 'DRIVER',
  DRIVER_SHARED_ACCOUNT = 'DRIVER_SHARED_ACCOUNT',
  HANDOVER = 'HANDOVER',
  ADMIN = 'ADMIN',
  USER = 'USER'
}
